import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

interface FieldChangeEvent {
  fieldKey: string;
  value: string;
}

@Component({
  selector: 'app-job-request-test-api-fluid-loss-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-request-test-api-fluid-loss-detail.component.html',
  styleUrl: './job-request-test-api-fluid-loss-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobRequestTestApiFluidLossDetailComponent {
  @Input({ required: true }) testKey = '';
  @Input({ required: true }) fieldValueByKey!: (testKey: string, fieldKey: string) => string;

  @Output() fieldChanged = new EventEmitter<FieldChangeEvent>();

  protected onFieldInput(fieldKey: string, value: string): void {
    this.fieldChanged.emit({ fieldKey, value });
  }
}
